import { icon as alert } from "@elastic/eui/es/components/icon/assets/alert";
import { icon as arrowDown } from "@elastic/eui/es/components/icon/assets/arrow_down";
import { icon as arrowLeft } from "@elastic/eui/es/components/icon/assets/arrow_left";
import { icon as arrowRight } from "@elastic/eui/es/components/icon/assets/arrow_right";
import { icon as arrowUp } from "@elastic/eui/es/components/icon/assets/arrow_up";
import { icon as brush } from "@elastic/eui/es/components/icon/assets/brush";
import { icon as check } from "@elastic/eui/es/components/icon/assets/check";
import { icon as checkInCircleFilled } from "@elastic/eui/es/components/icon/assets/checkInCircleFilled";
import { icon as clock } from "@elastic/eui/es/components/icon/assets/clock";
import { icon as cloudSunny } from "@elastic/eui/es/components/icon/assets/cloudSunny";
import { icon as copy } from "@elastic/eui/es/components/icon/assets/copy";
import { icon as cross } from "@elastic/eui/es/components/icon/assets/cross";
import { icon as desktop } from "@elastic/eui/es/components/icon/assets/desktop";
import { icon as dot } from "@elastic/eui/es/components/icon/assets/dot";
import { icon as editorUndo } from "@elastic/eui/es/components/icon/assets/editor_undo";
import { icon as empty } from "@elastic/eui/es/components/icon/assets/empty";
import { icon as exit } from "@elastic/eui/es/components/icon/assets/exit";
import { icon as eye } from "@elastic/eui/es/components/icon/assets/eye";
import { icon as grid } from "@elastic/eui/es/components/icon/assets/grid";
import { icon as home } from "@elastic/eui/es/components/icon/assets/home";
import { icon as iInCircle } from "@elastic/eui/es/components/icon/assets/iInCircle";
import { icon as image } from "@elastic/eui/es/components/icon/assets/image";
import { icon as magnifyWithMinus } from "@elastic/eui/es/components/icon/assets/magnifyWithMinus";
import { icon as magnifyWithPlus } from "@elastic/eui/es/components/icon/assets/magnifyWithPlus";
import { icon as menu } from "@elastic/eui/es/components/icon/assets/menu";
import { icon as minus } from "@elastic/eui/es/components/icon/assets/minus";
import { icon as moon } from "@elastic/eui/es/components/icon/assets/moon";
import { icon as pause } from "@elastic/eui/es/components/icon/assets/pause";
import { icon as pencil } from "@elastic/eui/es/components/icon/assets/pencil";
import { icon as play } from "@elastic/eui/es/components/icon/assets/play";
import { icon as plus } from "@elastic/eui/es/components/icon/assets/plus";
import { icon as plusInCircle } from "@elastic/eui/es/components/icon/assets/plus_in_circle";
import { icon as questionInCircle } from "@elastic/eui/es/components/icon/assets/question_in_circle";
import { icon as refresh } from "@elastic/eui/es/components/icon/assets/refresh";
import { icon as save } from "@elastic/eui/es/components/icon/assets/save";
import { icon as search } from "@elastic/eui/es/components/icon/assets/search";
import { icon as snowflake } from "@elastic/eui/es/components/icon/assets/snowflake";
import { icon as sortDown } from "@elastic/eui/es/components/icon/assets/sort_down";
import { icon as sortUp } from "@elastic/eui/es/components/icon/assets/sort_up";
import { icon as sortable } from "@elastic/eui/es/components/icon/assets/sortable";
import { icon as sortLeft } from "@elastic/eui/es/components/icon/assets/sortLeft";
import { icon as sortRight } from "@elastic/eui/es/components/icon/assets/sortRight";
import { icon as stop } from "@elastic/eui/es/components/icon/assets/stop";
import { icon as trash } from "@elastic/eui/es/components/icon/assets/trash";
import { icon as user } from "@elastic/eui/es/components/icon/assets/user";
/* eslint-disable import/no-duplicates */
// NOTE: This file exists because of a known issue with EUI icons dynamic import.
// https://github.com/elastic/eui/issues/5463#issuecomment-1107665339
//
// Only icons actually used in the app are imported here to keep the bundle small.
//
import { appendIconComponentCache } from "@elastic/eui/es/components/icon/icon";

export const registerEuiIcons = () => {
    appendIconComponentCache({
        alert,
        arrowDown,
        arrowLeft,
        arrowRight,
        arrowUp,
        brush,
        check,
        checkInCircleFilled,
        clock,
        copy,
        cross,
        desktop,
        dot,
        moon,
        cloudSunny,
        pause,
        play,
        editorUndo,
        empty,
        exit,
        eye,
        grid,
        home,
        iInCircle,
        image,
        magnifyWithMinus,
        magnifyWithPlus,
        menu,
        minus,
        pencil,
        plus,
        plusInCircle,
        questionInCircle,
        refresh,
        save,
        search,
        snowflake,
        sortable,
        sortDown,
        sortLeft,
        sortRight,
        sortUp,
        stop,
        trash,
        user,
    });
};
